import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { BankStatementLineContainer } from '../../../../../../models/aggregates/erp/index';


@Injectable({
    providedIn: 'root'
})
export class BankStatementLineService extends BaseApiTemplateService<BankStatementLineContainer> {
    
    readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/bank-statement/lines'

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/bank-statement/lines';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/bank-statement/lines';
        this.httpClient = http;
    }
    
}

